import React from 'react';
import { default as ButtonMaterial, ButtonProps } from '@material-ui/core/Button';
import { makeButtonStyles } from 'styles/components/button';

export enum BUTTON_THEME {
    CLEAR_FILTERS = 'CLEAR_FILTERS',
}

export type BUTTON_COLOR_THEME = 'darkgray' | 'gray' | 'outlinedPrimary';

type Props = ButtonProps & {
    colorTheme?: BUTTON_COLOR_THEME;
    theme?: BUTTON_THEME;
    component?: any;
    isOrderPanel?: boolean;
} & any;

const Button: React.FC<Props> = ({
    children,
    colorTheme,
    theme,
    isOrderPanel,
    ...props }) => {
    const buttonClasses = makeButtonStyles({ colorTheme, theme, isOrderPanel });

    return (
        <ButtonMaterial classes={buttonClasses} {...props}>
            {children}
        </ButtonMaterial>
    );
};

Button.defaultProps = {
    variant: 'contained',
};

export default Button;
